var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box__no-content"},[_c('svgicon',{staticClass:"svg-icon--logo",attrs:{"icon":"logo-img","width":"60"}}),_c('p',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }